"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertmanagerApi = exports.AlertmanagerApiFactory = exports.AlertmanagerApiFp = exports.AlertmanagerApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AlertmanagerApi - axios parameter creator
 * @export
 */
const AlertmanagerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {WebhookDTO} [webhookDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertmanagerResourceAlertWebhook: (webhookDTO_1, ...args_1) => __awaiter(this, [webhookDTO_1, ...args_1], void 0, function* (webhookDTO, options = {}) {
            const localVarPath = `/alertmanager/alertWebhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(webhookDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertmanagerApiAxiosParamCreator = AlertmanagerApiAxiosParamCreator;
/**
 * AlertmanagerApi - functional programming interface
 * @export
 */
const AlertmanagerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertmanagerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {WebhookDTO} [webhookDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertmanagerResourceAlertWebhook(webhookDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.alertmanagerResourceAlertWebhook(webhookDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlertmanagerApi.alertmanagerResourceAlertWebhook']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AlertmanagerApiFp = AlertmanagerApiFp;
/**
 * AlertmanagerApi - factory interface
 * @export
 */
const AlertmanagerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertmanagerApiFp)(configuration);
    return {
        /**
         *
         * @param {AlertmanagerApiAlertmanagerResourceAlertWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertmanagerResourceAlertWebhook(requestParameters = {}, options) {
            return localVarFp.alertmanagerResourceAlertWebhook(requestParameters.webhookDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertmanagerApiFactory = AlertmanagerApiFactory;
/**
 * AlertmanagerApi - object-oriented interface
 * @export
 * @class AlertmanagerApi
 * @extends {BaseAPI}
 */
class AlertmanagerApi extends base_1.BaseAPI {
    /**
     *
     * @param {AlertmanagerApiAlertmanagerResourceAlertWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertmanagerApi
     */
    alertmanagerResourceAlertWebhook(requestParameters = {}, options) {
        return (0, exports.AlertmanagerApiFp)(this.configuration).alertmanagerResourceAlertWebhook(requestParameters.webhookDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertmanagerApi = AlertmanagerApi;
//# sourceMappingURL=alertmanager-api.js.map